<template>
  <v-switch
      v-model="switchValue"
      :id="control.uniqueId"
      :name="control.name || control.uniqueId"
      :disabled="control.isDisabled"
      @click="updateValue(switchValue)"
  />
</template>

<script>
import {BaseControlSkeleton} from 'v-form-builder';

export default {
  name: 'SwitchControl',
  extends: BaseControlSkeleton,
  data: () => ({
    switchValue: null,
  }),

  async mounted() {
    const r = Promise.all([
      await new Promise((resolve) => setTimeout(() => resolve(), 500)),
      this.switchValue = this.value,
    ]);
  },

  // watch: {
  //   value: (val) => (),
  // },
};
</script>
